import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

const brandOverview = createApi({
  baseQuery: fetchBaseQueryCSRF({ baseUrl: process.env.CROSS_API_URL }),
  reducerPath: 'api.brandOverview',
  tagTypes: ['brandOverview'],
  endpoints: (builder) => ({
    getPerformanceSplit: builder.query<any, {
      workspaceId: any,
      platforms: string[] | null,
      devices: string[] | null,
      countries: string[] | null,
      start_date: string | null,
      end_date: string | null,
      compare_start_date: string | null,
      compare_end_date: string | null,
      savingsFormula?: string,
      timestep?: string,
      split: 'country' | 'platform' | 'date' | 'device',
      compare: any,
      bqTable: any,
      sinceActivate?: any
    }>({
      query: ({ workspaceId, sinceActivate, platforms, devices, countries, bqTable, start_date, end_date, compare_start_date, compare_end_date, savingsFormula, timestep, split, compare }) => {
        const url = `/brandOverview/getPerformanceSplit`;
        const body = {
          workspaceId,
          platforms,
          devices,
          countries,
          start_date,
          end_date,
          compare_start_date,
          compare_end_date,
          savingsFormula,
          timestep,
          split,
          compare,
          bqTable,
          sinceActivate
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getKpis: builder.query<any, { compareStartDate: string | null, compareEndDate: string | null, startDate: string | null, endDate: string | null, devices: string[] | null, countries: string[], keywords: string[], timestep: string, workspaceId: any | null, platforms: any }>({
      query: ({ startDate, endDate, devices, countries, keywords, timestep, compareStartDate, compareEndDate, workspaceId, platforms }) => {
        const url = `/brandOverview/query/kpis`;
        const body = {
          startDate,
          endDate,
          compareStartDate,
          compareEndDate,
          devices,
          countries,
          keywords,
          timestep,
          workspaceId,
          platforms
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
  }),
});

export const {
  useGetPerformanceSplitQuery,
  useGetKpisQuery
} = brandOverview;

export default brandOverview;
